var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"color":"green"}},[_c('v-tab',[_vm._v("Attivi")]),_c('v-tab',[_vm._v("Archivio")]),_c('v-tab-item',[_c('OrdiniAttivi')],1),_c('v-tab-item',[_c('OrdiniEvasi')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }